import { BaseApi } from "./BaseApi";

export class AgenteDiaUtilApi extends BaseApi {
    async CalcularPrevisaoEntregaOrcamento(codigoFilial: string) : Promise<Date> {
        return (await this.api.get(`/AgenteDiaUtil/CalcularPrevisaoEntregaOrcamento`, {
          params: {
            codigoFilial
      }})).data
    }
}